module.exports = __webpack_public_path__ + "img/engrenagem.a7b2e683.svg";